export class AccountLoginModel {
    email = null;
    password = null;
    isEmailValid = true;
    isPasswordValid = true;
  }
  